import React from "react";
import "./Schedule.scss";
import FadeInSection from "./FadeInSection";
import RingsIcon from "./images/rings.webp";

function Schedule() {
  return (
    <div className="bg-base">
      <div className="timeline p-top-8 p-bottom-8">
        <FadeInSection>
          <div className="timeline-container left">
            <div className="content shadow-default">
              <h2 className="flex flex-align-center">
                <i className="fa-solid fa-house m-right-1 text-xl" />
                <span className="text-primary h4 font-body font-weight-700">09:00</span>
              </h2>
              <h4 className="m-bottom-1 m-top-1">В дома на Mладоженеца</h4>
              <p className="m-bottom-1">
                <strong>Място:</strong> кв. Повеляново, гр. Девня
              </p>
              <p className="m-bottom-1">
                Младоженецът ще посрещне близки и приятели в родния си дом, където ще започне подготовката за големия ден.
              </p>
            </div>
            <div className="timeline-clock">
              <div className="timeline-arrow-minutes timeline-arrow-minutes-0"></div>
              <div className="timeline-clock-circle"></div>
              <div className="timeline-arrow-hour timeline-arrow-hour-9"></div>
            </div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container right">
            <div className="content shadow-default">
              <h2 className="flex flex-align-center">
                <i className="fa-solid fa-user-group m-right-1 text-xl" />
                <span className="text-primary h4 font-body font-weight-700">10:30</span>
              </h2>
              <h4 className="m-bottom-1 m-top-1">Вземане на Kумове</h4>
              <p className="m-bottom-1">
                <strong>Място:</strong> кв. Повеляново, гр. Девня
              </p>
              <p className="m-bottom-1">
                Кумовете с радост ще посрещнат своя Младоженец в дома си и ще го съпроводят с благословия към неговата любима.
              </p>
            </div>
            <div className="timeline-clock">
              <div className="timeline-arrow-minutes timeline-arrow-minutes-30"></div>
              <div className="timeline-clock-circle"></div>
              <div className="timeline-arrow-hour timeline-arrow-hour-10"></div>
            </div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container left">
            <div className="content shadow-default">
              <h2 className="flex flex-align-center">
                <i className="fa-solid fa-house-lock m-right-1 text-xl" />
                <span className="text-primary h4 font-body font-weight-700">12:30</span>
              </h2>
              <h4 className="m-bottom-1 m-top-1">Кражба на Булката</h4>
              <p className="m-bottom-1">
                <strong>Място:</strong> гр. Дългопол
              </p>
              <p className="m-bottom-1">
                Булката ще бъде строго охранявана в родния си дом – само най-смелият Младоженец ще успее да я „откупи"!
              </p>
            </div>
            <div className="timeline-clock">
              <div className="timeline-arrow-minutes timeline-arrow-minutes-30"></div>
              <div className="timeline-clock-circle"></div>
              <div className="timeline-arrow-hour timeline-arrow-hour-12"></div>
            </div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container right">
            <div className="content shadow-default">
              <h2 className="flex flex-align-center">
                <i className="fa-solid fa-hotel m-right-1 text-xl" />
                <span className="text-primary h4 font-body font-weight-700">13:00-14:30</span>
              </h2>
              <h4 className="m-bottom-1 m-top-1">Времето за Настаняване</h4>
              <p className="m-bottom-1">
                След като Младоженецът открадне Булката, двамата ще се отправят към първата си сватбена фотосесия. През това време гостите ще имат възможност да се настанят в хотелите или къщите под наем, да си отдъхнат и да се подготвят за следващия вълнуващ момент от сватбата.
              </p>
            </div>
            <div className="timeline-clock">
              <div className="timeline-arrow-minutes timeline-arrow-minutes-0"></div>
              <div className="timeline-clock-circle"></div>
              <div className="timeline-arrow-hour timeline-arrow-hour-13"></div>
            </div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container left">
            <div className="content shadow-default">
              <h2 className="flex flex-align-center">
                <i className="fa-solid fa-church m-right-1 text-xl" />
                <span className="text-primary h4 font-body font-weight-700">15:00</span>
              </h2>
              <h4 className="m-bottom-1 m-top-1">Църковен брак</h4>
              <p className="m-bottom-1">
                <strong>Място:</strong> с. Аспарухово
              </p>
              <p className="m-bottom-1">
                Църковният брак ще бъде сключен в малка китна църква сгушена сред красивата природа на с. Аспарухово - Църква "Света Петка".
              </p>
            </div>
            <div className="timeline-clock">
              <div className="timeline-arrow-minutes timeline-arrow-minutes-0"></div>
              <div className="timeline-clock-circle"></div>
              <div className="timeline-arrow-hour timeline-arrow-hour-15"></div>
            </div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container right">
            <div className="content shadow-default">
              <h2 className="flex flex-align-center">
                <i className="fa-solid m-top-1 fa-martini-glass-citrus m-right-1 text-xl" />
                <span className="text-primary h4 font-body font-weight-700">16:00</span>
              </h2>
              <h4 className="m-bottom-1 m-top-1">Welcome drinks</h4>
              <p className="m-bottom-1">
                <strong>Място:</strong> Почивен комплекс “Овеч”
              </p>
            </div>
            <div className="timeline-clock">
              <div className="timeline-arrow-minutes timeline-arrow-minutes-0"></div>
              <div className="timeline-clock-circle"></div>
              <div className="timeline-arrow-hour timeline-arrow-hour-16"></div>
            </div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container left">
            <div className="content shadow-default">
              <h2 className="flex flex-align-center">
                <img
                  alt=""
                  src={RingsIcon}
                  style={{ width: 30 }}
                  className="flex m-right-1 text-xl"
                />
                <span className="text-primary h4 font-body font-weight-700">17:00</span>
              </h2>
              <h4 className="m-bottom-1 m-top-1">Граждански брак</h4>
              <p className="m-bottom-1">
                <strong>Място:</strong> Почивен комплекс "Овеч"
              </p>
              <p className="m-bottom-1">
                Красив хотел, намиращ се в с. Аспарухово и разположен на брега на яз. Цонево.
              </p>
            </div>
            <div className="timeline-clock">
              <div className="timeline-arrow-minutes timeline-arrow-minutes-0"></div>
              <div className="timeline-clock-circle"></div>
              <div className="timeline-arrow-hour timeline-arrow-hour-17"></div>
            </div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container right">
            <div className="content shadow-default">
              <h2 className="flex flex-align-center">
                <i className="fa-solid fa-camera m-right-1 text-xl" />
                <span className="text-primary h4 font-body font-weight-700">17:30</span>
              </h2>
              <h4 className="m-bottom-1 m-top-1">Снимки и поздравления</h4>
              <p className="m-bottom-1">
                <strong>Място:</strong> Почивен комплекс "Овеч"
              </p>
              <p className="m-bottom-1">
                Младоженците, заедно с техните Kумове, ще приемат вашите поздравления, а фотографът ще запечата този красив момент.
              </p>
            </div>
            <div className="timeline-clock">
              <div className="timeline-arrow-minutes timeline-arrow-minutes-30"></div>
              <div className="timeline-clock-circle"></div>
              <div className="timeline-arrow-hour timeline-arrow-hour-17"></div>
            </div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container left">
            <div className="content shadow-default">
              <h2 className="flex flex-align-center">
                <i className="fa-brands fa-fort-awesome m-right-1 text-xl" />
                <span className="text-primary h4 font-body font-weight-700">19:00</span>
              </h2>
              <h4 className="m-bottom-1 m-top-1">Сватбено тържество</h4>
              <p className="m-bottom-1">
                <strong>Място:</strong> Почивен комплекс "Овеч"
              </p>
              <p className="m-bottom-1">
                В ресторанта с красива гледка към язовира ще сложим началото на сватбеното празненство.
              </p>
            </div>
            <div className="timeline-clock">
              <div className="timeline-arrow-minutes timeline-arrow-minutes-0"></div>
              <div className="timeline-clock-circle"></div>
              <div className="timeline-arrow-hour timeline-arrow-hour-19"></div>
            </div>
          </div>
        </FadeInSection>
        <FadeInSection>
          <div className="timeline-container right">
            <div className="content shadow-default">
              <h2 className="flex flex-align-center">
                <i className="fa-solid fa-people-pulling m-right-1 text-xl" />
                <span className="text-primary h4 font-body font-weight-700">20:00</span>
              </h2>
              <h4 className="m-bottom-1 m-top-1">Сватбени ритуали и обичаи</h4>
              <p className="m-bottom-1">
                Кой ще командва у дома?
              </p>
            </div>
            <div className="timeline-clock">
              <div className="timeline-arrow-minutes timeline-arrow-minutes-0"></div>
              <div className="timeline-clock-circle"></div>
              <div className="timeline-arrow-hour timeline-arrow-hour-20"></div>
            </div>
          </div>
        </FadeInSection>
      </div>
    </div>
  );
}

export default Schedule;
